import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'jquery/dist/jquery.min.js';
import $ from 'jquery';
import {Trash2} from "react-feather";
import {deleteKeywordItem, getKeywordList} from "../../API/keyword";

class KeywordToolViewComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            keywordListData: [],
        };
    }


    async componentDidMount() {
        let ignoreList = await getKeywordList().then(function (result) {
            return JSON.stringify(result);
        });

        ignoreList = JSON.parse(ignoreList);

        const ignoreListData = ignoreList.map((o) => (
            <tr key={o.objectID}>
                <td>{o.objectID}</td>
                <td>{o.keyword}</td>
                <td>{o.tag}</td>

                <td>
                    <button onClick={() => deleteKeywordItem(o.objectID)}
                            className="btn btn-danger">
                        <Trash2/>
                    </button>
                </td>
            </tr>
        ));

        this.setState({
            keywordListData: ignoreListData,
        });

        //initialize datatable
        $(document).ready(function () {
            let table = $("#keywordListTable").DataTable({
                pageLength: 100,
                language: {
                    fontcolor: "white",
                    url: "https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json", // German Language - DataTable Plugin
                },
            });
            table.draw();
        });
    }

    render() {
        return (
            <div className="container handwai-dark">
                <table
                    id="ignoreListTable"
                    className="table advicesTableText"
                    data-page-length="100"
                >
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Keyword</th>
                        <th>Tag</th>
                        <th>Aktion</th>
                    </tr>
                    </thead>
                    <tbody>{this.state.keywordListData}</tbody>
                </table>
            </div>
        );
    }
}


export default KeywordToolViewComponent;